import {
  getEnvironmentName,
  isProduction
} from "parog-web/utils/runtime-environment";
import type { Issuer } from "./open-id-connect";
import OpenIdConnectService from "./open-id-connect";

export default class AphpConnectMedic extends OpenIdConnectService {
  label = "APHP Connect";
  imageUrl = "/assets/ui-images/aphp.png";
  issuer: Issuer = "aphp-medic";
  route = "login.aphp-medics";

  get isEnabled() {
    return !isProduction() && getEnvironmentName() != "release";
  }
}
